import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Store } from '@ngxs/store';
import { UtmState } from '../states/utm.state';
import { Guid, Utility } from '../core/common';
import { SharedService } from './shared.service';
import { RecaptchaHeader, RecaptchaService } from './recaptcha.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(private store: Store, private http: HttpClient, private recaptchaService: RecaptchaService) { }
  get guestId(): string {
    const key = 'auth-guestid';
    let value = localStorage.getItem(key);
    if (!value) {
      value = Guid.newGuid();
      localStorage.setItem(key, value);
    }
    return value;
  }

  get isLoggedIn() {
    return !!this.store.selectSnapshot(state => state.auth.user);
  }

  async current() {
    return this.http.get(environment.app.apiUrl + 'auth/current', { params: {cb: Date.now()}, observe: 'response', headers: { 'x-kp-alive': 'true' }, context: SharedService.NO_LOADING_BAR }).toPromise();
  }

  async update(user: any) {
    return this.http.post(environment.app.apiUrl + 'auth/update', user, { observe: 'response', headers: { 'x-kp-alive': 'true' } }).toPromise();
  }

  async logout() {
    return this.http.get(environment.app.apiUrl + 'auth/logout', { headers: { 'x-kp-alive': 'true' } }).toPromise();
  }

  async authenticate(mobile: string, otp = false, headers?: RecaptchaHeader) {
    if (!headers) { headers = await this.recaptchaService.header('authenticate'); }
    const utm = this.store.selectSnapshot(UtmState.utm);
    let params = {};
    if (otp) params['otp'] = 'true';
    return this.http.post<any>(environment.app.apiUrl + 'auth/authenticate/' + mobile, utm, { params, headers: {...headers, 'x-kp-alive': 'true' } }).toPromise();
  }

  async confirm(mobile: string, code: string, info?: any, headers?: RecaptchaHeader) {
    if (!headers) { headers = await this.recaptchaService.header('confirm'); }
    return this.http.post(environment.app.apiUrl + 'auth/confirm/' + mobile, code, { headers, params: Utility.removeUndefined(info), observe: 'response' }).toPromise();
  }

  async daanAuthenticate(payload: string) {
    return this.http.post<any>(environment.app.apiUrl + 'auth/daanAuthenticate', JSON.stringify(payload), { observe: 'response', headers: { 'x-kp-alive': 'true' } }).toPromise();
  }


  async login(username: string, password: string, headers?: RecaptchaHeader) {
    if (!headers) { headers = await this.recaptchaService.header('login'); }
    return this.http.post(environment.app.apiUrl + 'auth/login/' + username, JSON.stringify(password), { observe: 'response', headers: {...headers, 'x-kp-alive': 'true' } }).toPromise();
  }

  async generateCode(mobile: string) {
    return this.http.get(environment.app.apiUrl + 'auth/code/' + mobile).toPromise();
  }

  async checkConfirm(mobile: string, code: string, info?: any) {
    return this.http.post<{User?: any, Code?: string}>(environment.app.apiUrl + 'auth/check-confirm/' + mobile, code, { params: Utility.removeUndefined(info), observe: 'response', headers: { 'x-kp-alive': 'true' } }).toPromise();
  }
}
